/**
 * Auto-generated home-row fingering drills: home + top/bottom (same finger)
 * e.g. q → aq drill, z → az drill
 */

import { getPairInstruction } from './fingerKeyMap';

/** Home row key → top row & bottom row (same finger column) */
export const HOME_FINGER_COLUMNS = [
  { home: 'a', top: 'q', bottom: 'z', fingerLabel: 'Left Little Finger' },
  { home: 's', top: 'w', bottom: 'x', fingerLabel: 'Left Ring Finger' },
  { home: 'd', top: 'e', bottom: 'c', fingerLabel: 'Left Middle Finger' },
  { home: 'f', top: 'r', bottom: 'v', fingerLabel: 'Left Index Finger' },
  { home: 'j', top: 'u', bottom: 'm', fingerLabel: 'Right Index Finger' },
  { home: 'k', top: 'i', bottom: ',', fingerLabel: 'Right Middle Finger' },
  { home: 'l', top: 'o', bottom: '.', fingerLabel: 'Right Ring Finger' },
  { home: ';', top: 'p', bottom: '/', fingerLabel: 'Right Little Finger' },
];

/** Classic tutor pattern: aqaq aqaq qqaa qqaa aqaq aqaq */
export const buildClassicPairDrill = (homeKey, extKey) => {
  const pair = `${homeKey}${extKey}`;
  const reverse = `${extKey}${homeKey}`;
  const double = pair + pair;
  const reverseDouble = reverse[0] + reverse[0] + pair[0] + pair[0];
  return `${double} ${double} ${reverseDouble} ${reverseDouble} ${double} ${double}`;
};

/** Shorter drill for punctuation keys */
export const buildSimplePairDrill = (homeKey, extKey) => {
  const pair = `${homeKey}${extKey}`;
  const spaced = `${pair} ${pair} ${pair} ${pair} ${pair} ${pair}`;
  return `${buildClassicPairDrill(homeKey, extKey)} ${spaced}`;
};

const makePairLesson = (homeKey, extKey, rowLabel, fingerLabel, index) => {
  const displayExt = extKey === ',' ? ',' : extKey === ';' ? ';' : extKey.toUpperCase();
  const displayHome = homeKey === ';' ? ';' : homeKey.toUpperCase();
  const id = `f-${homeKey}-${extKey}`.replace(/[^a-z0-9-]/g, '');
  return {
    id,
    title: `${displayHome} & ${displayExt} (${rowLabel})`,
    homeKey,
    extKey,
    text: extKey === ',' || extKey === '.' || extKey === '/'
      ? buildSimplePairDrill(homeKey, extKey)
      : buildClassicPairDrill(homeKey, extKey),
    focusKeys: [homeKey, extKey],
    instructionText: getPairInstruction(homeKey, extKey),
    fingerLabel,
    order: index,
  };
};

export const buildFingeringLessons = () => {
  const lessons = [
    {
      id: 'f-intro',
      title: 'Home Row — ASDF JKL;',
      showHomeIntro: true,
      text: 'asdf jkl; asdf jkl; fad fad jkl jkl; a s d f j k l ;',
      focusKeys: ['a', 's', 'd', 'f', 'j', 'k', 'l', ';'],
      order: 0,
    },
  ];

  let order = 1;
  HOME_FINGER_COLUMNS.forEach((col) => {
    lessons.push(
      makePairLesson(col.home, col.top, 'Top Row', col.fingerLabel, order),
    );
    order += 1;
    lessons.push(
      makePairLesson(col.home, col.bottom, 'Bottom Row', col.fingerLabel, order),
    );
    order += 1;
  });

  lessons.push(
    {
      id: 'f-review-home',
      title: 'Home Row Review',
      text: 'asdf jkl; asdf jkl; fad fad jkl jkl; sad lad fad dad',
      focusKeys: ['a', 's', 'd', 'f', 'j', 'k', 'l', ';'],
      order,
    },
    {
      id: 'f-review-words',
      title: 'Home Row Words',
      text: 'ask ask fall fall dash dash flask flask salad salad lad lad',
      focusKeys: ['a', 's', 'd', 'f', 'j', 'k', 'l'],
      order: order + 1,
    },
    {
      id: 'f-review-mixed',
      title: 'All Rows Mixed',
      text: 'quick brown fox jumps over lazy dog pack my box',
      order: order + 2,
    },
  );

  return lessons;
};
